module.exports = __webpack_public_path__ + "img/FB_Info_Game_Page_2.9f610c11.png";